import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["navbar"];

  initialize() {
    this.prevScrollPos = window.scrollY;
  }

  connect() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const currentScrollPos = window.scrollY;
    const tolerance = 5;

    if (currentScrollPos <= tolerance) {
      this.navbarTarget.classList.remove("hidden");
    } else if (currentScrollPos > this.prevScrollPos) {
      this.navbarTarget.classList.add("hidden");
    } else {
      this.navbarTarget.classList.remove("hidden");
    }

    this.prevScrollPos = currentScrollPos;
  }
}
